/** Cross-origin beta handoff. Journey encodes; REChecklist claims. */

export const BETA_HANDOFF_SALT = "dhj-rechecklist-beta-v1";
export const BETA_HANDOFF_VERSION = 1;

function checksum(payload) {
  const source = `${BETA_HANDOFF_SALT}:${JSON.stringify(payload)}`;
  let hash = 2166136261;
  for (let i = 0; i < source.length; i += 1) {
    hash ^= source.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(16);
}

function toBase64Url(value) {
  const bytes = unescape(encodeURIComponent(value));
  return btoa(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function fromBase64Url(value) {
  const padded = String(value || "").replace(/-/g, "+").replace(/_/g, "/");
  const pad = padded.length % 4 === 0 ? "" : "=".repeat(4 - (padded.length % 4));
  return decodeURIComponent(escape(atob(padded + pad)));
}

export function encodeBetaHandoff(profile = {}) {
  const inner = {
    v: BETA_HANDOFF_VERSION,
    firstName: String(profile.firstName || "").trim(),
    lastName: String(profile.lastName || "").trim(),
    email: String(profile.email || "").trim().toLowerCase(),
    phone: String(profile.phone || "").trim(),
    role: profile.role === "broker" ? "broker" : "agent",
    brokerage: String(profile.brokerage || "").trim(),
    license: String(profile.license || "").trim(),
    acceptedAt: profile.acceptedAt || new Date().toISOString(),
    issuedAt: new Date().toISOString(),
  };
  const envelope = { ...inner, sig: checksum(inner) };
  return toBase64Url(JSON.stringify(envelope));
}

export function decodeBetaHandoff(token) {
  if (!token) return null;
  try {
    const envelope = JSON.parse(fromBase64Url(token));
    if (!envelope || envelope.v !== BETA_HANDOFF_VERSION) return null;
    const { sig, ...inner } = envelope;
    if (sig !== checksum(inner)) return null;
    if (!inner.email || !inner.firstName || !inner.lastName) return null;
    if (inner.role !== "agent" && inner.role !== "broker") return null;
    return inner;
  } catch {
    return null;
  }
}

export function betaHandoffQuery(profile) {
  const params = new URLSearchParams({
    beta: "1",
    handoff: encodeBetaHandoff(profile),
  });
  return `/?${params.toString()}`;
}
